import { render, staticRenderFns } from "./DashboardFilters.vue?vue&type=template&id=fb65b496&"
import script from "./DashboardFilters.vue?vue&type=script&lang=js&"
export * from "./DashboardFilters.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb65b496')) {
      api.createRecord('fb65b496', component.options)
    } else {
      api.reload('fb65b496', component.options)
    }
    module.hot.accept("./DashboardFilters.vue?vue&type=template&id=fb65b496&", function () {
      api.rerender('fb65b496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/dashboard/views/components/DashboardFilters.vue"
export default component.exports